import React, { useEffect } from 'react';
import { CircularProgress } from '@mui/material';

import { useAuth0 } from "@auth0/auth0-react";
import { clearAuthData } from '../../services/storage.ts';

function LogoutRedirect() {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    clearAuthData();
    return loginWithRedirect({});
  }, []);

  return (
    <div style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh',
    }}
    >
      <CircularProgress />
    </div>
  );
}

export default LogoutRedirect;
